import React from 'react';
import CmsComponent from '../../components/CmsComponent';
import { calculateColumnsRelativeToParent } from './calculate-columms-relative-to-parent';
const CmsComponentGrid = ({ asContentLocation = false, childComponents = [], cqResponsive, name = 'content-location', position = null, preloadImages, }) => {
    if (!childComponents || childComponents.length < 1)
        return null;
    const renderCmsComponents = () => childComponents.map((component, index) => {
        const modifiedComponent = Object.assign(Object.assign({}, component), { cqResponsive: cqResponsive && component.cqResponsive
                ? calculateColumnsRelativeToParent(component.cqResponsive, cqResponsive)
                : component.cqResponsive });
        return (React.createElement(CmsComponent, { key: component.componentId, component: modifiedComponent, position: `${position}-${index + 1}`, index: index, preloadImages: preloadImages }));
    });
    return asContentLocation ? (React.createElement("div", { id: `cms-${name}-content`, "data-testid": "cms-content-location" }, renderCmsComponents())) : (renderCmsComponents());
};
export default CmsComponentGrid;
//# sourceMappingURL=index.js.map